// extracted by mini-css-extract-plugin
export var changeIcon = "_4z-4";
export var container = "_4z-0";
export var divider = "_4z-7";
export var externalLinkIcon = "_4z-1";
export var green = "_4z-5";
export var helpCircleIcon = "_4z-3";
export var iconButton = "_4z-2";
export var red = "_4z-6";